module.exports = __webpack_public_path__ + "img/IMG_6258_L.17fb69f5.webp";